module.exports = __webpack_public_path__ + "static/media/hoc-t1.a56c1869.svg";